<template>
    <v-layout row wrap justify-start>
        <v-flex 
            v-for="f in registers"
            :key="f._id"
            pa-3
            xs12 sm6 md4 lg3 xl3>
            <Sparkline 
                :title="f.name"
                :id="f._id"
                :caption="periodScope.text"
                :labels="f.data.map(x => (periodScope.value === 'last24h') ? new Date(x.createdAt).getHours() : new Date(x.createdAt).getDate()).reverse()"
                :value="f.data.map(x => x.newEntered-x.newExited || 0).reverse()"
            />
                <!-- :subheading="[`${f.current} Contatos Atuais`,`${f.newEntries} Novas Entradas`,`${f.newExits} Novas Saídas`]" -->
        </v-flex>
    </v-layout>
</template>

<script>
import Sparkline from './Sparkline'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('registers')

export default {
    name: 'Downloads',
    components: { Sparkline },
    props: ['id'],
    data: function() {
        return {
            registers: []
        }
    },
    computed: {
	    ...mapGetters(['downloadsStats', 'periodScope']),
    },
    methods: {
        ...mapActions(['loadRecords']),
        
        initialize() {
            // const id = (this.id) ? `${this.id}/` : ''
            this.loadRecords({ scope: 'downloadsStats', path: 'downloadsStats', segment: 'getLast24h'})
                .then(() => {if (this.registers.length === 0) this.registers = this.downloadsStats} )
                .catch(e => console.log(e))
        }
    },
    watch: {
        // periodScope (val) {
        //     this.registers = this[`funnels${val.value.charAt(0).toUpperCase()+val.value.slice(1)}`]
        // },
        id (val) {
            this.initialize()
        },
    },
    created() {
        this.initialize()
        
        setInterval(() => {
            this.initialize()
        }, 1000*60);
    }
}
</script>

<style>
</style>
